import React, { Component } from 'react';
import MaterialTable from '@material-table/core';
import CircularProgress from '@mui/material/CircularProgress';
import AuthStore from '../../Auth/AuthStore';
import './report.css';
import { fetchWithAuth } from '../../Auth/GlobalFetchWithAuth';
import PeriodPicker from '../Scheduller/PeriodPicker';

export class PeopleCosts extends Component {
    columns = [
        { title: 'Человек', field: 'name' },
        { title: 'Проектные часы', field: 'projectHours' },
        { title: 'Внутренние часы', field: 'otherHours' },
        { title: 'Роль', field: 'role', isGroup: true, defaultGroupOrder: 0 },
    ];

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            dates: {
                start: null
            }
        };

        this.loadReport = this.loadReport.bind(this);
        this.handlePeriodChange = this.handlePeriodChange.bind(this);
    }

    componentDidMount() {
        this.loadReport();
    }

    loadReport() {
        var scope = this;
        var start = new Date();
        scope.setState({ loading: true });
        if (!!scope.state.dates && !!scope.state.dates.start) {
            start = scope.state.dates.start;
        }
        fetchWithAuth('api/Schedulle/PeopleHoursByWeek?start=' + start.toISOString(),
            null,
            null,
            res => {
                scope.setState({ costs: res, loading: false });
            },
            'GET'
        )
    }

    handlePeriodChange(dates) {
        this.setState({ dates: dates }, () => { this.loadReport() });
    }

    render() {
        return (
            <div>
                <h3>КВ. Трудозатраты</h3>
                <PeriodPicker viewType={0} onPeriodChange={this.handlePeriodChange} />
                {this.state.loading && <div className="block-progress-mask"><CircularProgress color="inherit" /></div>}
                {!this.state.loading && <>
                    <MaterialTable
                        title=""
                        columns={this.columns}

                        data={this.state.costs}
                        editable={{
                        }}
                        actions={[

                        ]}
                        options={{
                            grouping: true
                        }}
                    />
                </>}
            </div>
        )
    }
}